module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Utalvány értéke","track":"Your voucher amount"}}